export default __webpack_public_path__ + "static/media/sajjad.486c8f72.pdf";